// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage_root__J-Gfo","CodeMirror":"ErrorPage_CodeMirror__+vdT-","errorPage":"ErrorPage_errorPage__dfz9c","container":"ErrorPage_container__91s4E"};